module.exports = __webpack_public_path__ + "img/flavor7.68e689f0.png";